import React from 'react';
import './CellOverflow.scss';

interface CellOverflowProps {
  /** Chipy widoczne w komórce; reszta chowa się pod znacznikiem „+N”. */
  chips: React.ReactNode[];
  /** Ile chipów zostaje w komórce. */
  visibleCount?: number;
  emptyLabel: string;
  /** Tytuł i etykieta przycisku „+”. */
  openTitle: string;
  onOpen: () => void;
}

/**
 * Komórka tabeli: kilka pierwszych chipów, „+N” za resztę i przycisk „+” otwierający edycję.
 *
 * Wiersz tabeli musi mieć stałą wysokość (jak w Reports), więc lista nie może rosnąć w komórce.
 * „+” jest też przy pustej liście — inaczej nie dałoby się dodać pierwszej pozycji.
 */
export const CellOverflow: React.FC<CellOverflowProps> = ({
  chips,
  visibleCount = 2,
  emptyLabel,
  openTitle,
  onOpen,
}) => {
  const hidden = chips.length - visibleCount;

  return (
    <div className="cell-overflow">
      {chips.length === 0 ? (
        <span className="cell-overflow__empty">{emptyLabel}</span>
      ) : (
        <div className="cell-overflow__chips">
          {chips.slice(0, visibleCount).map((chip, index) => (
            <React.Fragment key={index}>{chip}</React.Fragment>
          ))}
          {hidden > 0 && <span className="cell-overflow__more">+{hidden}</span>}
        </div>
      )}

      <button
        type="button"
        className="cell-overflow__open"
        title={openTitle}
        aria-label={openTitle}
        onClick={onOpen}
      >
        <span className="ico ico--plus ico--xxs" />
      </button>
    </div>
  );
};

export default CellOverflow;
